import { Link } from '@tanstack/react-router';
import { ArrowLeft, Download, EyeOff, FolderOpen, Upload } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface Props {
    projectId: number;
    title: string;
    onBack: () => void;
}

export function Header({ projectId, title, onBack }: Props) {
    // TODO: Implement permissions to menu items similar to project-menu.tsx
    return (
        <div className="h-16 border-b bg-background px-6 flex items-center justify-between shadow-xs sticky top-0 z-[1000]">
            <div className="flex items-center gap-4">
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={onBack}
                    className="text-muted-foreground hover:text-foreground"
                >
                    <ArrowLeft className="h-4 w-4 mr-2" />
                    Back
                </Button>
                <div className="h-6 w-px bg-border" />
                <h1 className="text-xl font-bold text-foreground">{title}</h1>
            </div>
            <div className="flex items-center gap-2">
                <Link
                    to="/documents"
                    search={{ projectId, isProjectView: true }}
                >
                    <Button
                        variant="outline"
                        size="sm"
                        className="border-primary text-primary hover:bg-primary/10"
                        testId="ProjectHeader__documents"
                    >
                        <FolderOpen className="h-4 w-4 mr-2" />
                        Document Repository
                    </Button>
                </Link>
                <Button
                    variant="outline"
                    size="sm"
                    testId="ProjectHeader__toggleUtilization"
                >
                    <EyeOff className="h-4 w-4 mr-2" />
                    Toggle Utilization Data
                </Button>
                <Link
                    to="/documents/upload"
                    search={{ projectId, isProjectView: true }}
                >
                    <Button
                        variant="outline"
                        size="sm"
                        testId="ProjectHeader__upload"
                    >
                        <Upload className="h-4 w-4 mr-2" />
                        Upload Documentation
                    </Button>
                </Link>

                <Button
                    size="sm"
                    className="bg-foreground hover:bg-foreground/90 text-background"
                    testId="ProjectHeader__generateBinder"
                >
                    <Download className="h-4 w-4 mr-2" />
                    Generate Technical Binder
                </Button>
            </div>
        </div>
    );
}
